import React from 'react';

const AssetsLoadingShimmer: React.FC = () => {
    return (
        <div className="flex flex-row align-middle space-x-8 mt-2">
            {[...Array(4)].map((_, index) => (
                <div
                    key={index}
                    className="w-52 h-10 bg-gray-200 rounded-lg relative overflow-hidden"
                    style={{
                        background:
                            'linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 1.5s infinite',
                    }}
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-100 via-gray-300 to-gray-500 animate-pulse"></div>
                </div>
            ))}
        </div>
    );
};

export default AssetsLoadingShimmer;
